import { useMutation } from "react-query";
import URL from "core/resources/urls";
import http from "infra/http";

export function useCreateOrdemServico() {
  return useMutation(URL.ORDEM_SERVICO.OBTER, async (body: any) => {
    const response = await http.post(URL.ORDEM_SERVICO.OBTER, body);
    return response;
  });
}

export function useUpdateOrdemServico() {
   return useMutation(async ({ id, body }: { id: string; body: any }) => {
      const response = await http.put(URL.ORDEM_SERVICO.OBTER_POR_ID(id), body);
      return response;
  });
}

export function usePrinter() {
  return useMutation({
    mutationKey: [URL.ORDEM_SERVICO.EXPORTAR_PDF],
    mutationFn: async (ordemServicoId: string) => {
      const { data } = await http.get(URL.ORDEM_SERVICO.EXPORTAR_PDF(ordemServicoId), {
        params: {},
        responseType: "blob",
      });
      return data;
    },
  });
}

export default useCreateOrdemServico;
